import { jsPDF } from "jspdf";
import {
    standardQuoteImageX,
    standardQuoteImageY,
    standardQuoteImageWidth,
    standardQuoteImageHeight,
    formatYearFromDate,
    isCesgMaxedOut,
    isLanguageEnglish,
} from "./PDFGenerationUtils";

import EnrolmentForms_En3 from "./PageGenerators/Enrolment Forms/EnrolmentForms_En3";
import EnrolmentForms_En2 from "./PageGenerators/Enrolment Forms/EnrolmentForms_En2";
import {
    BENEFICIARY_SIGNER_ID,
    beneficiaryAge,
    GUARDIAN_SIGNER_ID,
    hasTemporarySin,
    JOINT_SUBSCRIBER_SIGNER_ID,
    PLAN_TYPE_IDS,
    SUBSCRIBER_SIGNER_ID,
    THIRD_PARTY_SIGNER_ID,
} from "../Utils/PlanUtils";
import IllustrationDisclosure_GroupEn1 from "./PageGenerators/Illustration Disclosure/IllustrationDisclosure_GroupEn1";
import CreditCard_En1 from "./PageGenerators/Credit Card/CreditCard_En1";
import EscrowEng1 from "./PageGenerators/Escrow Forms/Escrow - Eng - 1";
import EscrowEng2 from "./PageGenerators/Escrow Forms/Escrow - Eng - 2";
import RDI_En1 from "./PageGenerators/RDI/RDI_En1";
import RDI_En2 from "./PageGenerators/RDI/RDI_En2";
import RDI_En3 from "./PageGenerators/RDI/RDI_En3";
import RDI_En4 from "./PageGenerators/RDI/RDI_En4";
import RDI_En5 from "./PageGenerators/RDI/RDI_En5";
import RDI_En6 from "./PageGenerators/RDI/RDI_En6";
import RDI_En7 from "./PageGenerators/RDI/RDI_En7";
import RDI_En8 from "./PageGenerators/RDI/RDI_En8";
import ThirdLanguage_En1 from "./PageGenerators/Third Language/ThirdLanguage_En1";
import PQUAD_En1 from "./PageGenerators/PQAD/PQAD-English";
import ThirdParty_En1 from "./PageGenerators/Third Party/ThirdParty_English";
import Transfer_English1 from "./PageGenerators/Transfer/Transfer_English1";
import Transfer_English2 from "./PageGenerators/Transfer/Transfer_English2";
import Transfer_English3 from "./PageGenerators/Transfer/Transfer_English3";
import Transfer_English4 from "./PageGenerators/Transfer/Transfer_English4";
import Transfer_English5 from "./PageGenerators/Transfer/Transfer_English5";
import Transfer_English6 from "./PageGenerators/Transfer/Transfer_English6";
import OptionalInsurance_En from "./PageGenerators/Optional Insurance/OptionalInsurance_En";
import SKYC1English from "./PageGenerators/SKYC/SKYC-1English";
import SKYC2English from "./PageGenerators/SKYC/SKYC-2English";
import SKYCMaternity1English from "./PageGenerators/SKYC/SKYC-Maternity1English";
import SKYCMaternity2English from "./PageGenerators/SKYC/SKYC-Maternity2English";
import CASL_En from "./PageGenerators/CASL/CASL_En";

import GroupPlanSummaryEN1 from "./PageGenerators/Plan Summaries/Group Plan Summary-EN-1";
import GroupPlanSummaryEN2 from "./PageGenerators/Plan Summaries/Group Plan Summary-EN-2";
import GroupPlanSummaryEN3 from "./PageGenerators/Plan Summaries/Group Plan Summary-EN-3";
import GroupPlanSummaryEN4 from "./PageGenerators/Plan Summaries/Group Plan Summary-EN-4";

import SelfInitiatedPlanSummaryEN1 from "./PageGenerators/Plan Summaries/Self-Initiated Plan Summary-EN-1";
import SelfInitiatedPlanSummaryEN2 from "./PageGenerators/Plan Summaries/Self-Initiated Plan Summary-EN-2";
import SelfInitiatedPlanSummaryEN3 from "./PageGenerators/Plan Summaries/Self-Initiated Plan Summary-EN-3";
import SelfInitiatedPlanSummaryEN4 from "./PageGenerators/Plan Summaries/Self-Initiated Plan Summary-EN-4";

import AchieversPlanSummaryEN1 from "./PageGenerators/Plan Summaries/Achievers Plan Summary-EN-1";
import AchieversPlanSummaryEN2 from "./PageGenerators/Plan Summaries/Achievers Plan Summary-EN-2";
import AchieversPlanSummaryEN3 from "./PageGenerators/Plan Summaries/Achievers Plan Summary-EN-3";
import AchieversPlanSummaryEN4 from "./PageGenerators/Plan Summaries/Achievers Plan Summary-EN-4";
//import GrantLimitDisclosureDisclosure_En from "./PageGenerators/Grant Limit Disclosure/Grant_Limit_Disclosure_EN";
import TemproarySin_En1 from "./PageGenerators/Temporary SIN/TemproarySin_En1";
import IllustrationDisclosure_AchEn1 from "./PageGenerators/Illustration Disclosure/IllustrationDisclosure_AchEn1";
import IllustrationDisclosure_SIEn1 from "./PageGenerators/Illustration Disclosure/IllustrationDisclosure_SIEn1";
import CESG_English1 from "./PageGenerators/CESG/CESG_English1";
import CESG_English2 from "./PageGenerators/CESG/CESG_English2";
import CESG_English3 from "./PageGenerators/CESG/CESG_English3";
import CESG_English4 from "./PageGenerators/CESG/CESG_English4";
import CESG_EnglishB1 from "./PageGenerators/CESG/CESG_EnglishB1";
import CESG_EnglishB2 from "./PageGenerators/CESG/CESG_EnglishB2";
import CESG_EnglishB3 from "./PageGenerators/CESG/CESG_EnglishB3";
import CESG_EnglishC1 from "./PageGenerators/CESG/CESG_EnglishC1";
import CESG_EnglishC2 from "./PageGenerators/CESG/CESG_EnglishC2";
import CESG_EnglishC3 from "./PageGenerators/CESG/CESG_EnglishC3";
import CESG_EnglishD1 from "./PageGenerators/CESG/CESG_EnglishD1";
import CESG_EnglishD2 from "./PageGenerators/CESG/CESG_EnglishD2";
import CESG_EnglishD3 from "./PageGenerators/CESG/CESG_EnglishD3";
import ADULTCLB_English1 from "./PageGenerators/CESG/ADULTCLB_English1";
import ADULTCLB_English2 from "./PageGenerators/CESG/ADULTCLB_English2";
import ADULTCLB_English3 from "./PageGenerators/CESG/ADULTCLB_English3";
import EnrolmentForms_En4 from "./PageGenerators/Enrolment Forms/EnrolmentForms_En4";
import CesgMax_English from "./PageGenerators/CESG Max/CesgMax-English";
import { useAuthenticationStatus } from "../Authentication/AuthenticationStatusProvider";
import RDI_En9 from "./PageGenerators/RDI/RDI_En9";
import RDI_En10 from "./PageGenerators/RDI/RDI_En10";
import RDI_En11 from "./PageGenerators/RDI/RDI_En11";
import DualLicenseDisclosure_En1 from "./PageGenerators/Dual License Disclosure/DualLicenseDisclosure_En1";
import RestrictedClientDisclosure_En1 from "./PageGenerators/Restricted Client/RestrictedClient_En1.js";
import DRChecklist_En1 from "./PageGenerators/DR Checklist/DRChecklist_En1";

import KYC2English_Reg1 from "./PageGenerators/KYC2/English_Reg-1";
import KYC2English_Reg2 from "./PageGenerators/KYC2/English_Reg-2";
import KYC2English_Reg3 from "./PageGenerators/KYC2/English_Reg-3";

import KYC2English_Mat1 from "./PageGenerators/KYC2/English_Mat-1";
import KYC2English_Mat2 from "./PageGenerators/KYC2/English_Mat-2";
import KYC2English_Mat3 from "./PageGenerators/KYC2/English_Mat-3";

//Generates an enrollment package based on the current state
// This includes the base64 representation of all of the PDF pages
// Along with the description of who needs to sign and where
// returns a promise that resolves to an object with the following structure:
// {
//     enrolmentId: <enrolmentId>,
//     documents: [
//         {
//             documentId: string, //Unique document ID within the envelope.  Can be used to determine which signer sees what document
//             name: string,
//             fileExtension: string,
//             documentBase64: string
//         }
//     ],
//     signers: [
//         {
//             email: string,
//             name: string,
//             recipientId: string, //ID unique within the envelope that identifies the signer
//             inPersonSigner: boolean, //When true, the signer will be required to sign in person.  When false, they will be required to sign via an email.
//             signHereTabs: [
//                 {
//                     xPosition: number
//                     yPosition: number
//                 }
//             ]
//         }
//     ]
// }
// The documents array contains the base64 representation of the PDF pages
// The signers array contains the information about who needs to sign and where
// The signHereTabs array contains the x and y position of where the signature should be placed
export const generateEnrollmentPackage = (
    state,
    quote,
    quote2,
    authenticationStatus,
    i18n,
) => {
    return generateEnrollmentPackageDocumentsForDocusignEnvelope(
        state,
        quote,
        quote2,
        authenticationStatus,
        i18n,
    ) //generateEnrolmentDocumentPDFToBase64(state, quote)
        .then((documents) => {
            /*
            const documentId = '1';
            const documents = [{
                documentId: documentId, //TODO: We will probably need more than one document when we are sending to different people
                name: 'Enrolment Package',
                fileExtension: 'pdf',
                documentBase64: documentBase64
            }]

             */

            const signers = [];

            for (const d of documents) {
                const pages = d.pages; // enrolmentDocumentPages(state); //The specific pages of the enrollment package based on the state

                // We need to consolidate all of the signature information from each page into one list
                for (let i = 0; i < pages.length; i++) {
                    const page = pages[i];
                    if (page !== "quote" && page !== "quote2") {
                        //We don't sign the quote page

                        //For other pages, we get the signature definition from that page's configuration
                        const pageSigners = page.signatureDefinitions(
                            state,
                            d.documentId,
                            i + 1,
                            i18n,
                            authenticationStatus,
                        );
                        if (!pageSigners) {
                            continue;
                        }

                        //We then loop through each signer and add them to the list
                        for (let j = 0; j < pageSigners.length; j++) {
                            const signerId = Object.keys(pageSigners[j])[0];
                            //We check if the signer has already been added to the list
                            const existingSigner = signers.find(
                                (signer) => Object.keys(signer)[0] === signerId,
                            );

                            if (!existingSigner) {
                                //If not, we add them to the list
                                signers.push(pageSigners[j]);
                            } else {
                                //If they do exist, we add the tabs to the existing signer
                                existingSigner[signerId].push(
                                    ...pageSigners[j][signerId],
                                );
                            }
                        }
                    }
                }
            }

            //signers now contains one entry for each signer, with a list of tabs for each signer
            // Now we need to add in the specific details about the signers since right now we just have their ID
            let retSigners = [];
            for (let i = 0; i < signers.length; i++) {
                const signer = signers[i];
                const signerId = Object.keys(signer)[0];
                const tabs = signer[signerId];

                //Assume agent is the signer
                let name = state.agent.firstName + " " + state.agent.lastName;
                let email = state.agent.email;
                let inPersonSigner = state.agent.inPersonSigner;
                let mobilePhone = null; //DR always should sign in person
                //Default subject for Subscriber, Joint Subscriber, and Beneficiary
                let emailSubject = `Please DocuSign: RESP Opening Documents for ${(state.beneficiary.firstName + " " + state.beneficiary.lastName).trim()}`;
                if (!isLanguageEnglish(i18n)) {
                    //French subject
                    emailSubject = `Veuillez signer par DocuSign : Documents d'ouverture de REEE pour ${(state.beneficiary.firstName + " " + state.beneficiary.lastName).trim()}`;
                }

                if (signerId === SUBSCRIBER_SIGNER_ID) {
                    name =
                        state.subscriber.firstName +
                        " " +
                        state.subscriber.lastName;
                    email = state.subscriber.email;
                    inPersonSigner = state.subscriber.inPersonSigner;
                    mobilePhone = state.subscriber.mobilePhone;
                    //use default subject for Subscribers
                }
                if (signerId === JOINT_SUBSCRIBER_SIGNER_ID) {
                    name =
                        state.jointSubscriber.firstName +
                        " " +
                        state.jointSubscriber.lastName;
                    email = state.jointSubscriber.email;
                    inPersonSigner = state.jointSubscriber.inPersonSigner;
                    mobilePhone = state.jointSubscriber.mobilePhone;
                    //use default subject for Subscribers
                }
                if (signerId === BENEFICIARY_SIGNER_ID) {
                    name =
                        state.beneficiary.firstName +
                        " " +
                        state.beneficiary.lastName;
                    email = state.beneficiary.email;
                    inPersonSigner = state.beneficiary.inPersonSigner;
                    mobilePhone = state.beneficiary.mobilePhone;
                    //use default subject for Beneficiary
                }
                if (signerId === THIRD_PARTY_SIGNER_ID) {
                    name = state.knowYourClient.thirdPartyName;
                    email = state.knowYourClient.thirdPartyEmail;
                    inPersonSigner =
                        state.knowYourClient.thirdPartyInPersonSigner;
                    mobilePhone = state.knowYourClient.thirdPartyPhone;
                    if (isLanguageEnglish(i18n)) {
                        emailSubject =
                            "Please DocuSign: Disclosure of Third Party Financial Support for " +
                            state.beneficiary.firstName +
                            " " +
                            state.beneficiary.lastName;
                    } else {
                        emailSubject =
                            "Veuillez DocuSign : Divulgation du soutien financier d'un tiers pour  " +
                            state.beneficiary.firstName +
                            " " +
                            state.beneficiary.lastName;
                    }
                }
                if (signerId === GUARDIAN_SIGNER_ID) {
                    name =
                        state.application.custodianFirstName +
                        " " +
                        state.application.custodianLastName;
                    email = state.application.custodianEmail;
                    inPersonSigner = state.application.custodianInPersonSigner;
                    mobilePhone = state.application.custodianMobilePhone;
                    //Specific subject for Guardian
                    if (isLanguageEnglish(i18n)) {
                        emailSubject =
                            "Please DocuSign: Annex B for " +
                            state.beneficiary.firstName +
                            " " +
                            state.beneficiary.lastName;
                    } else {
                        emailSubject =
                            "Veuillez signer par DocuSign : Annexe B pour " +
                            state.beneficiary.firstName +
                            " " +
                            state.beneficiary.lastName;
                    }
                }

                const newSigner = {
                    email: email,
                    emailSubject: emailSubject,
                    emailLanguage: isLanguageEnglish(i18n) ? "en" : "fr", //This is how the language of the forms is determined, so we also make the email language match
                    name: name,
                    mobilePhone: mobilePhone,
                    recipientId: signerId,
                    inPersonSigner: inPersonSigner,
                    signHereTabs: tabs.filter((tab) => {
                        return !tab.initials;
                    }),
                    initialHereTabs: tabs.filter((tab) => {
                        return tab.initials;
                    }),
                    excludedDocuments: documents
                        .filter((doc, index) => {
                            //Find all documents where this signer is excluded
                            return (
                                doc.excludedSigners &&
                                Array.isArray(doc.excludedSigners) &&
                                doc.excludedSigners.includes(signerId)
                            );
                        })
                        .map((doc, index) => {
                            return doc.documentId;
                        }),
                };
                retSigners.push(newSigner);
            }

            //retSigners now contains one entry for each signer, with their email, name, recipientId, and a list of tabs
            // for all pages of the enrollment package

            return {
                enrollmentId: state.enrollment._id,
                documents,
                emailSubject: `Please DocuSign: RESP Opening Documents for ${(state.beneficiary.firstName + " " + state.beneficiary.lastName).trim()}`,
                signers: retSigners,
            };
        });
};

export const generateEnrolmentDocumentPDFToBlob = (
    data,
    quote,
    quote2,
    authenticationStatus,
    i18n,
) => {
    const doc = generateEnrolmentDocumentPDF(
        data,
        quote,
        quote2,
        authenticationStatus,
        i18n,
    );
    return doc.output("blob");
};

export const generateEnrolmentDocumentPDFToBase64 = (
    data,
    quote,
    quote2,
    authenticationStatus,
) => {
    return new Promise((resolve, reject) => {
        const doc = generateEnrolmentDocumentPDFToBlob(
            data,
            quote,
            quote2,
            authenticationStatus,
        );
        const reader = new FileReader();

        reader.onloadend = () => {
            const base64data = reader.result.split(",")[1];
            resolve(base64data);
        };
        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(doc);
    });
};

//Generates an enrolment package based on the current state
// The enrolment package consists of a number of "documents", each with one or more "pages".
export const generateEnrolmentDocumentPDF = (
    data,
    quote,
    quote2,
    authenticationStatus,
    i18n,
) => {
    let doc = new jsPDF({ format: "letter" });

    const documents = enrollmentPackageDocuments(data, authenticationStatus);

    let pageCount = 0;
    let docCount = 0;

    for (const d of documents) {
        if (docCount > 0) {
            doc.addPage();
        }

        console.log("docCount: " + docCount);

        generateEnrollmentPackagePDForDocument(
            data,
            quote,
            d,
            quote2,
            doc,
            authenticationStatus,
            i18n,
        );
        docCount++;
        /*
        const pages = d.pages; //enrolmentDocumentPages(data);

        for (let i = 0; i < pages.length; i++) {
            const page = pages[i];

            if (pageCount > 0) {
                doc.addPage();
            }
            pageCount++;
            if (page === 'quote') {
                let width = doc.getImageProperties(quote).width;
                let height = doc.getImageProperties(quote).height;
                const scaleFactor = 200 / width;

                //doc.addImage(image, 'PNG', 5, (297 - (height * scaleFactor)) / 2.0, width * scaleFactor, height * scaleFactor, '', 'FAST');
                doc.addImage(quote, "PNG", standardQuoteImageX, standardQuoteImageY, width * scaleFactor, height * scaleFactor, 'QUOTE', 'FAST');
            } else if (page === 'quote2') {
                let width = doc.getImageProperties(quote2).width;
                let height = doc.getImageProperties(quote2).height;
                const scaleFactor = 200 / width;

                doc.addImage(quote2, "PNG", standardQuoteImageX, standardQuoteImageY, width * scaleFactor, height * scaleFactor, 'QUOTE2', 'FAST');
            } else {
                page.generate(doc, data);
            }

        }

         */
    }
    return doc;
};

export const generateEnrollmentPackageDocumentsForDocusignEnvelope = (
    data,
    quote,
    quote2,
    authenticationStatus,
    i18n,
) => {
    const documents = enrollmentPackageDocuments(data, authenticationStatus);

    let promises = [];

    for (const d of documents) {
        promises.push(
            generateEnrollmentPackagePDForDocumentToBase64(
                data,
                quote,
                d,
                quote2,
                authenticationStatus,
                i18n,
            ),
        );
    }

    return Promise.all(promises).then((documentBase64Values) => {
        let i = 0;
        for (const d of documents) {
            d.documentBase64 = documentBase64Values[i];
            i++;
        }
        return documents;
    });
};

export const generateEnrollmentPackagePDForDocumentToBlob = (
    data,
    quote,
    document,
    quote2,
    authenticationStatus,
    i18n,
) => {
    const doc = generateEnrollmentPackagePDForDocument(
        data,
        quote,
        document,
        quote2,
        null,
        authenticationStatus,
        i18n,
    );
    return doc.output("blob");
};

export const generateEnrollmentPackagePDForDocumentToBase64 = (
    data,
    quote,
    document,
    quote2,
    authenticationStatus,
    i18n,
) => {
    return new Promise((resolve, reject) => {
        const doc = generateEnrollmentPackagePDForDocumentToBlob(
            data,
            quote,
            document,
            quote2,
            authenticationStatus,
            i18n,
        );
        const reader = new FileReader();

        reader.onloadend = () => {
            const base64data = reader.result.split(",")[1];
            resolve(base64data);
        };
        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(doc);
    });
};

// Generates a PDF document for a specific document in the enrollment package
// doc is optionally an existing jsPDF document.  If not provided, a new one will be created.
// doc is returned at the end.
export const generateEnrollmentPackagePDForDocument = (
    data,
    quote,
    document,
    quote2,
    doc,
    authenticationStatus,
    i18n,
) => {
    if (!doc) {
        doc = new jsPDF({ format: "letter" });
    }

    const pages = document.pages; //enrolmentDocumentPages(data);

    for (let i = 0; i < pages.length; i++) {
        const page = pages[i];

        if (i > 0) {
            doc.addPage();
        }
        if (page === "quote") {
            let width = doc.getImageProperties(quote).width;
            let height = doc.getImageProperties(quote).height;
            const scaleFactor = 210 / width;

            //doc.addImage(image, 'PNG', 5, (297 - (height * scaleFactor)) / 2.0, width * scaleFactor, height * scaleFactor, '', 'FAST');
            doc.addImage(
                quote,
                "PNG",
                standardQuoteImageX,
                standardQuoteImageY,
                width * scaleFactor,
                height * scaleFactor,
                "QUOTE",
                "FAST",
            );
        } else if (page === "quote2") {
            let width = doc.getImageProperties(quote2).width;
            let height = doc.getImageProperties(quote2).height;
            const scaleFactor = 210 / width;

            doc.addImage(
                quote2,
                "PNG",
                standardQuoteImageX,
                standardQuoteImageY,
                width * scaleFactor,
                height * scaleFactor,
                "QUOTE2",
                "FAST",
            );
        } else {
            page.generate(doc, data, undefined, authenticationStatus, i18n);
        }
    }

    return doc;
};

export const enrollmentPackageDocuments = (state, authenticationStatus) => {
    let quoteDisclosurePage = IllustrationDisclosure_GroupEn1;

    console.log("state.plan.planTypeID: " + state.plan.planTypeID);

    if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        quoteDisclosurePage = IllustrationDisclosure_GroupEn1;
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        quoteDisclosurePage = IllustrationDisclosure_AchEn1;
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
        quoteDisclosurePage = IllustrationDisclosure_SIEn1;
    }

    let quotePages = ["quote", quoteDisclosurePage];
    if (
        state.plan2.planTypeID >= 0 &&
        state.plan2.planTypeID != PLAN_TYPE_IDS.TRANSFER
    ) {
        if (state.plan2.planTypeID === PLAN_TYPE_IDS.GROUP) {
            quoteDisclosurePage = IllustrationDisclosure_GroupEn1;
        } else if (state.plan2.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
            quoteDisclosurePage = IllustrationDisclosure_AchEn1;
        } else if (state.plan2.planTypeID === PLAN_TYPE_IDS.SI) {
            quoteDisclosurePage = IllustrationDisclosure_SIEn1;
        }

        quotePages.push("quote2");
        quotePages.push(quoteDisclosurePage);
    }

    const quote = {
        documentId: "1", //TODO: We will probably need more than one document when we are sending to different people
        name: "Plan Quotation",
        fileExtension: "pdf",
        pages: quotePages,
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const enrollmentForm = {
        documentId: "2", //TODO: We will probably need more than one document when we are sending to different people
        name: "Enrolment Form",
        fileExtension: "pdf",
        pages: [EnrolmentForms_En2, EnrolmentForms_En3, EnrolmentForms_En4],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const thirdLanguage = {
        documentId: "3", //TODO: We will probably need more than one document when we are sending to different people
        name: "Third Language",
        fileExtension: "pdf",
        pages: [ThirdLanguage_En1],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const RDI = {
        documentId: "4", //TODO: We will probably need more than one document when we are sending to different people
        name: "Relationship Disclosure",
        fileExtension: "pdf",
        pages: [
            RDI_En1,
            RDI_En2,
            RDI_En3,
            RDI_En4,
            RDI_En5,
            RDI_En6,
            RDI_En7,
            RDI_En8,
            RDI_En9,
            RDI_En10,
            RDI_En11,
        ],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const escrowForm = {
        documentId: "5", //TODO: We will probably need more than one document when we are sending to different people
        name: "Escrow Form",
        fileExtension: "pdf",
        pages: [EscrowEng1, EscrowEng2],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const creditCard = {
        documentId: "6", //TODO: We will probably need more than one document when we are sending to different people
        name: "Credit Card",
        fileExtension: "pdf",
        pages: [CreditCard_En1],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const PQAD = {
        documentId: "8", //TODO: We will probably need more than one document when we are sending to different people
        name: "PQAD",
        fileExtension: "pdf",
        pages: [PQUAD_En1],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const ThirdParty = {
        documentId: "9",
        name: "Third Party",
        fileExtension: "pdf",
        pages: [ThirdParty_En1],
        excludedSigners: [GUARDIAN_SIGNER_ID],
    };

    const TransferForm = {
        documentId: "10",
        name: "Transfer Form",
        fileExtension: "pdf",
        pages: [
            Transfer_English1,
            Transfer_English2,
            Transfer_English3,
            Transfer_English4,
            Transfer_English5,
            Transfer_English6,
        ],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const OptionalInsurance = {
        documentId: "11",
        name: "Optional Insurance",
        fileExtension: "pdf",
        pages: [OptionalInsurance_En],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const KYC2 = {
        documentId: "12",
        name: "Know Your Client",
        fileExtension: "pdf",
        pages: [KYC2English_Reg1, KYC2English_Reg2, KYC2English_Reg3],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const KYC2Maternity = {
        documentId: "13",
        name: "Know Your Client",
        fileExtension: "pdf",
        pages: [KYC2English_Mat1, KYC2English_Mat2, KYC2English_Mat3],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const CASL = {
        documentId: "14",
        name: "Electronic Communication Consent",
        fileExtension: "pdf",
        pages: [CASL_En],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const GroupPlanSummary = {
        documentId: "15",
        name: "Group Plan Summary",
        fileExtension: "pdf",
        pages: [
            GroupPlanSummaryEN1,
            GroupPlanSummaryEN2,
            GroupPlanSummaryEN3,
            GroupPlanSummaryEN4,
        ],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const SiPlanSummary = {
        documentId: "16",
        name: "Self-Initiated Plan Summary",
        fileExtension: "pdf",
        pages: [
            SelfInitiatedPlanSummaryEN1,
            SelfInitiatedPlanSummaryEN2,
            SelfInitiatedPlanSummaryEN3,
            SelfInitiatedPlanSummaryEN4,
        ],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const AchieversPlanSummary = {
        documentId: "17",
        name: "Achievers Plan Summary",
        fileExtension: "pdf",
        pages: [
            AchieversPlanSummaryEN1,
            AchieversPlanSummaryEN2,
            AchieversPlanSummaryEN3,
            AchieversPlanSummaryEN4,
        ],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    /*    const GrantLimitDisclosure = {
         documentId: '19',
         name: 'Grant Limit Disclosure',
         fileExtension: 'pdf',
         pages: [
             GrantLimitDisclosureDisclosure_En
         ],
         excludedSigners: [
             GUARDIAN_SIGNER_ID,
             THIRD_PARTY_SIGNER_ID
         ]
     }
*/
    const TemporarySin = {
        documentId: "20",
        name: "Temporary SIN",
        fileExtension: "pdf",
        pages: [TemproarySin_En1],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const CESG = {
        documentId: "21",
        name: "CESG and CLB Application Form",
        fileExtension: "pdf",
        pages: [CESG_English1, CESG_English2, CESG_English3, CESG_English4],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const CESGB = {
        documentId: "22",
        name: "CESGB",
        fileExtension: "pdf",
        pages: [CESG_EnglishB1, CESG_EnglishB2, CESG_EnglishB3],
        excludedSigners: [THIRD_PARTY_SIGNER_ID],
    };

    const CESGC = {
        documentId: "23",
        name: "CESGC",
        fileExtension: "pdf",
        pages: [CESG_EnglishC1, CESG_EnglishC2, CESG_EnglishC3],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const CESGD = {
        documentId: "24",
        name: "CESGD",
        fileExtension: "pdf",
        pages: [CESG_EnglishD1, CESG_EnglishD2, CESG_EnglishD3],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const CLBAdult = {
        documentId: "25",
        name: "Adult CLB Application",
        fileExtension: "pdf",
        pages: [ADULTCLB_English1, ADULTCLB_English2, ADULTCLB_English3],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const CESGMax = {
        documentId: "26",
        name: "CESGMax",
        fileExtension: "pdf",
        pages: [CesgMax_English],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const dualLicense = {
        documentId: "27",
        name: "Dual License",
        fileExtension: "pdf",
        pages: [DualLicenseDisclosure_En1],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const restrictedClient = {
        documentId: "28",
        name: "Restricted Client",
        fileExtension: "pdf",
        pages: [RestrictedClientDisclosure_En1],
        excludedSigners: [GUARDIAN_SIGNER_ID, THIRD_PARTY_SIGNER_ID],
    };

    const drChecklist = {
        documentId: "29",
        name: "DR Checklist",
        fileExtension: "pdf",
        pages: [DRChecklist_En1],
        excludedSigners: [
            SUBSCRIBER_SIGNER_ID,
            JOINT_SUBSCRIBER_SIGNER_ID,
            GUARDIAN_SIGNER_ID,
            THIRD_PARTY_SIGNER_ID,
        ],
    };

    let documents = [];

    // TODO includes quote and disclosure need to implement this logic somehow
    /*
    if (state.plan.planTypeID =Rest 0) { // if group
        pages.push(IllustrationDisclosure_GroupEn1) // TODO should be dependant on plan type
    } else if (state.plan.planTypeID == 1) { // if SI
        // TODO create page for SI
    } else if (state.plan.planTypeID == 2) {
        // TODO create page for achievers
    }
     */
    if (
        !(
            beneficiaryAge(state.beneficiary.birthdate) >= 18 &&
            formatYearFromDate(state.beneficiary.birthdate) >= 2004
        )
    ) {
        //Do not display qwuotes for adult CLB
        documents.push(quote);
    }

    // TODO if required add second disclosure for additional plan type
    documents.push(enrollmentForm);

    // kyc or maternity kyc TODO need to implement this logic
    const isMaternity = state.knowYourClient.kycFormType == 1; // 1 is Maternity KYC
    if (isMaternity) {
        documents.push(KYC2Maternity);
    } else {
        documents.push(KYC2);
    }

    // TODO plan disclosure (group, SI, achievers)

    // RDI - always enabled
    documents.push(RDI);

    // Referral Disclosure - always enabled - Seems to be part of RDI now
    // documents.push(referralDisclosure);
    if (state.common.signingProvince == "PQ") {
        // only display in Quebec
        // PQAD
        documents.push(PQAD);
    }
    // TODO NBAD (discontinued?)
    // third party
    if (state.knowYourClient.thirdPartyFinacialSupportForm) {
        // only display Third Party when support form is enabled in KYC
        documents.push(ThirdParty);
    }
    // TODO CESGMax --> Need logic for when CESG is max, function required

    if (isCesgMaxedOut(state) || state.drChecklist.grantLimitsExplained) {
        documents.push(CESGMax);
    }

    // TODO GESGAdult or GESG2Page or CESG6Page --> Government Grants need to be updated

    // TODO: Need insurance logic to be created - Based on if the DR is insurance licensed by some other organizat

    const plan = state.plan;
    const plan2 = state.plan2;
    const common = state.common;

    let insuranceJoint = common.subscriber2Include;

    const inQuebec = common.signingProvince === "PQ";

    // Drawing the form
    // group insurance
    let groupCriticalIllness =
        (plan.planTypeID === PLAN_TYPE_IDS.GROUP &&
            plan.criticalIllnessInsurance) ||
        (plan2.planTypeID === PLAN_TYPE_IDS.GROUP &&
            plan2.criticalIllnessInsurance);

    let groupNominee =
        (plan.planTypeID === PLAN_TYPE_IDS.GROUP && plan.nomineeInsurance) ||
        (plan2.planTypeID === PLAN_TYPE_IDS.GROUP && plan2.nomineeInsurance);
    let groupQCCcompletion =
        (plan.planTypeID === PLAN_TYPE_IDS.GROUP &&
            inQuebec &&
            plan.completionInsurance) ||
        (plan2.planTypeID === PLAN_TYPE_IDS.GROUP &&
            inQuebec &&
            plan2.completionInsurance);

    let anyCriticalIllness =
        plan.criticalIllnessInsurance || plan2.criticalIllnessInsurance;
    let anyNominee = plan.nomineeInsurance || plan2.nomineeInsurance;

    let anyOptionalInsurance =
        groupCriticalIllness ||
        groupNominee ||
        groupQCCcompletion ||
        anyCriticalIllness ||
        anyNominee;

    const isEitherSubscriberPCG =
        state.subscriber.primaryCaregiver ||
        (state.common.subscriber2Include &&
            state.jointSubscriber.primaryCaregiver);

    if (
        beneficiaryAge(state.beneficiary.birthdate) >= 18 &&
        formatYearFromDate(state.beneficiary.birthdate) >= 2004
    ) {
        documents.push(CLBAdult);
    } else {
        if (formatYearFromDate(state.beneficiary.birthdate) >= 2004) {
            documents.push(CESG);
        }
    }

    if (!isEitherSubscriberPCG) {
        documents.push(CESGB);
    }

    console.log("authStatus", authenticationStatus);
    console.log("agentCode", state.common.agentCode);

    const agent = authenticationStatus.user.agentCodes.find(
        (ac) => ac.code === state.common.agentCode,
    );

    console.log("agent", agent);

    if (
        anyOptionalInsurance &&
        authenticationStatus &&
        authenticationStatus.user &&
        agent &&
        agent.insuranceLicensedYN
    ) {
        // optional insurance
        documents.push(OptionalInsurance);
    }

    // Restricted Client
    if (
        authenticationStatus &&
        authenticationStatus.user &&
        agent &&
        agent.restrictedClientYN
    ) {
        documents.push(restrictedClient);
    }

    // Dual License Disclosure
    if (
        authenticationStatus &&
        authenticationStatus.user &&
        agent &&
        agent.dualLicenseYN
    ) {
        documents.push(dualLicense);
    }

    // Escrow
    if (state.beneficiary.sin == "") {
        // only display escrow if SIN is blank
        documents.push(escrowForm);
    }

    // Temporary SIN
    if (hasTemporarySin(state)) {
        documents.push(TemporarySin);
    }

    if (
        state.application.grantProvincial &&
        state.common.signingProvince == "BC"
    ) {
        documents.push(CESGD);
    }

    // TODO SAGES (discontinued?)
    // TODO ACES (discontinued?)

    console.log("transfer preadded");

    if (state.plan2.planTypeID == PLAN_TYPE_IDS.TRANSFER) {
        // only display transfer when one is requested TODO: This needs to be tested, but transfers are not enabled in the input screens yet
        // transfer form
        documents.push(TransferForm);
    }

    console.log("transfer added");

    // TODO this is never set...
    if (state.knowYourClient.applyForCreditCard) {
        // only when applying for a credit card
        // Credit Card
        documents.push(creditCard);
    }

    // 3rd language
    if (state.common.representativeDetails === true) {
        // only display third language when subscriber neither understands english or french
        documents.push(thirdLanguage);
    }

    // CD disclosure - Now part of RDI?
    // documents.push(ConflictDisclosure);
    /*
     if (state.drChecklist.grantLimitsExplained) {
         // Grant Limit Disclosure
         documents.push(GrantLimitDisclosure);
     }
*/
    if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
        // if Group Plan
        // Group Plan Summary
        documents.push(GroupPlanSummary);
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
        // if SI
        // Self-Initiated Plan Summary
        documents.push(SiPlanSummary);
    } else if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
        // if Achievers
        // Achiever's Plan Summary
        documents.push(AchieversPlanSummary);
    }

    // CASL -- always display CASL
    documents.push(CASL);

    // DR Checklist - always included
    documents.push(drChecklist);

    // TODO last page (needed?)

    return documents;
};
